import { render } from "./NavElemField.vue?vue&type=template&id=febb6ee0"
import script from "./NavElemField.vue?vue&type=script&lang=js"
export * from "./NavElemField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__